<template>
    <div class="initial_component">
        <ul class="columns is-multiline is-mobile">
            <div class="column is-one-fifth" v-for="i in intitial_data" :key="i.id">
                <router-link v-if="i != ''" :to="{name:'initial', params:{ id: i}}"><li>{{i}}</li></router-link>
            </div>
        </ul>
    </div>
</template>

<script>
export default {
    data(){
        return{
            intitial_data:[
                "あ","い","う","え","お",
                "か","き","く","け","こ",
                "さ","し","す","せ","そ",
                "た","ち","つ","て","と",
                "な","に","ぬ","ね","の",
                "は","ひ","ふ","へ","ほ",
                "ま","み","む","め","も",
                "や",'',"ゆ",'',"よ",
                "ら","り","る","れ","ろ",
                "わ",
            ],
        }
    }
}
</script>

<style scoped>
.initial_component{
    margin-right: 20px;
}
ul{
    font-size: 1.1em;
}
li{
  padding: 5px 20px 5px 20px;
  display: inline-block;
  text-decoration: none;
  text-align: center;
  color: #157DF0;
  font-weight: bold;
  border: solid 1px #157DF0;
}
li:hover {
  background: #157DF0;
  color: white;
}

</style>